module.exports = __webpack_public_path__ + "img/table_fr.31e25d98.jpg";